import React from 'react';
import styled from 'styled-components';
import { Row, Col } from 'reactstrap';
import { RebelTitle, RebelSubtitle } from '../../../styles/rebel-experiences';
import RebelSettingsList from './rebel-settings-list';

const RebelSettings = (props) => {
    return (
        <PageContainer>
            <Row>
                <Col style={{textAlign: "center"}}>
                    <RebelTitle>
                        R.E.B.E.L Config
                    </RebelTitle>
                    <RebelSubtitle>
                        Refined Elite Business & Executive Leisure Configuration
                    </RebelSubtitle>
                </Col>
            </Row>
            <RebelSettingsList />
        </PageContainer>
    )
}

export default RebelSettings;

const PageContainer = styled.div`
    padding: 30px 15px;
    height: 100%;
    box-sizing: border-box;
`;